// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18RYu","field":"styles_field__37xzO","fieldCol":"styles_fieldCol__3j5z2","diffCol":"styles_diffCol__qxZOk","diff":"styles_diff__20MXH"};